
const sectionMap = {
  cafes: "shopify-section-template--26647467491674__featured_collections_xaYhd8",
  ateliers: "shopify-section-template--26647467491674__multi_column_JNbRyk",
  coffeeshop: "shopify-section-template--26647467491674__text_with_media_aTPNLi",
  professionnels: "shopify-section-template--26647467491674__text_with_fixed_background_nF86Kx",
  apropos: "shopify-section-template--26647467491674__text_with_media_bD7KBj",
  contact: "shopify-section-template--26647467491674__contact_NKpURP"
};

// fonction de scroll fluide vers un ID de section
function scrollToSection(sectionId) {
  const el = document.getElementById(sectionId);
  if (!el) return;

  const offset = el.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({
    top: offset - 0, // ajuste ici selon la hauteur de ton header
    behavior: "smooth"
  });
}

// normalise un href et renvoie la "clé" logique (cafes, ateliers, ...)
function getAnchorKeyFromHref(href) {
  if (!href) return null;

  try {
    // si c'est une URL absolue, on l'utilise comme URL
    const url = href.startsWith("http")
      ? new URL(href)
      : new URL(href, window.location.origin);

    if (url.hash) {
      // cas /#cafes → "cafes"
      return url.hash.replace(/^#/, "");
    }

    // cas "/cafes" → "cafes"
    const path = url.pathname.replace(/^\/+/, ""); // enlève les "/" initiaux
    return path || null;
  } catch (e) {
    // au cas où ce ne soit pas une URL valide, fallback simple
    return href.replace(/^\/?#?/, "");
  }
}

// écouteur global sur le menu
document.addEventListener("click", (e) => {
  const link = e.target.closest("a");
  if (!link) return;

  const href = link.getAttribute("href");
  const key = getAnchorKeyFromHref(href);

  // si ce n'est pas une de nos ancres logiques, on laisse le comportement normal
  if (!key || !sectionMap[key]) return;

  const sectionId = sectionMap[key];
  const sectionExistsHere = !!document.getElementById(sectionId);

  // On intercepte le clic dans tous les cas
  e.preventDefault();

  // Fermer le menu mobile s'il est ouvert
  const menuDrawer = document.getElementById("menu-drawer");
  if (menuDrawer && menuDrawer.hasAttribute("open")) {
    menuDrawer.hide();
  }

  if (sectionExistsHere) {
    // 👉 On est sur la landing (ou une page qui contient ces sections)
    scrollToSection(sectionId);
  } else {
    // 👉 La section n'existe pas sur cette page : on renvoie vers la home avec l'ancre
    // Ça renverra vers : https://tondomaine.com/#cafes
    window.location.href = `${window.location.origin}/#${key}`;
  }
});

// Au chargement : si on arrive avec une ancre (#cafes) ET que la section existe, on scrolle
document.addEventListener("DOMContentLoaded", () => {
  const key = window.location.hash.replace(/^#/, "");
  const sectionId = sectionMap[key];

  if (sectionId && document.getElementById(sectionId)) {
    setTimeout(() => {
      scrollToSection(sectionId);
    }, 100);
  }
});

// Création du bouton flottant pour les cafés
function createFloatingCoffeeButton() {
  // Vérifier si le bouton existe déjà
  if (document.getElementById('floating-coffee-btn')) {
    return;
  }

  // Créer l'élément bouton
  const button = document.createElement('a');
  button.id = 'floating-coffee-btn';
  button.href = '/collections/cafes';
  button.className = 'floating-coffee-btn';
  button.setAttribute('aria-label', 'Voir nos cafés');

  // Créer l'image
  const img = document.createElement('img');
  img.src = 'https://freight.cargo.site/w/150/i/C2633857122969556295688347796615/bouton_eshop-06.png';
  img.alt = 'Bouton café';
  img.className = 'floating-coffee-btn-image';

  // Ajouter l'image au bouton
  button.appendChild(img);

  // Ajouter le bouton au body
  document.body.appendChild(button);
}

// Initialiser le bouton flottant au chargement de la page
// document.addEventListener('DOMContentLoaded', createFloatingCoffeeButton);


